export default __webpack_public_path__ + "b65da46d94529150f23f3a98c2ed079882d2392fd99dc3268390c6a8adb1d3ae.png";